import { useState } from 'react'
import { LoadingSplashOverlay, makeSplashVariant } from './loading-splash-overlay'

/**
 * Suspense fallback for lazily-loaded route chunks. Reuses the brand loading
 * splash so a code-split navigation looks identical to every other loading
 * state in the app (accessible `role="status"`, reduced-motion aware,
 * pointer-events pass through to the nav underneath).
 */
export function RouteFallback() {
  const [variant] = useState(makeSplashVariant)
  return <LoadingSplashOverlay variant={variant} exiting={false} />
}
